import Axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { caseKeys } from "src/query-keys";
import { Case, APIError, CaseBase } from "src/types";

/**
 * Deserialize the json format into a Javascript object
 */
function deserialize(data: CaseBase | Case): CaseBase | Case {
  return {
    ...data,
    dateCreated: new Date(data.dateCreated),
  };
}

export function useCase(caseId: string | number, options?: UseQueryOptions<Case, AxiosError<APIError[]>, Case>) {
  async function fetch(id: string | number): Promise<Case> {
    const response = await Axios.get(`/planning-api/cases/${id}`);
    return deserialize(response.data) as Case;
  }

  return useQuery<Case, AxiosError<APIError[]>>(caseKeys.detail(caseId), () => fetch(caseId), {
    ...options,
    staleTime: 60 * 60 * 1000,
  });
}
